import {
  findLeadgenInsertIndex,
  prepareBlocksForInterrupts,
  mergeUnbrokenListSplits,
  type ArticleBlock,
  type ArticleData,
} from '@benzinga/article-manager';
import { IN_CONTENT_SLOT_BLOCK_NAME, IN_CONTENT_SLOT_ID, isDisplayAdBlockName } from '@benzinga/ads-utils';

export { IN_CONTENT_SLOT_BLOCK_NAME, IN_CONTENT_SLOT_ID };

export const shouldAppendInContentBlocks = (article: ArticleData | null | undefined): boolean => {
  if (!article) return false;
  if (Number(article.blocks?.length) < 3) return false;
  const inContentBlocks = article.layout?.in_content?.blocks;
  if (!Array.isArray(inContentBlocks) || inContentBlocks.length === 0) return false;
  return !(inContentBlocks.length === 1 && inContentBlocks[0]?.blockName === 'acf/google-ad-placement');
};

export const inContentSlotMinHeightPx = (blocks: ArticleBlock[]): number => {
  const adsOnly = blocks.length > 0 && blocks.every(block => isDisplayAdBlockName(block.blockName));
  return adsOnly ? 250 : 350;
};

export const insertInContentBlocks = <Article extends ArticleData>(article: Article): Article => {
  if (!shouldAppendInContentBlocks(article)) return article;
  const blocks = [...(article.blocks || [])] as ArticleBlock[];
  if (blocks.some(block => block?.tagAttributes?.id === IN_CONTENT_SLOT_ID)) {
    return { ...article, blocks: mergeUnbrokenListSplits(blocks) };
  }

  const inContentBlocks = (article.layout?.in_content?.blocks || []) as ArticleBlock[];
  const minHeightPx = inContentSlotMinHeightPx(inContentBlocks);
  const sentinel: ArticleBlock = {
    attrs: {
      data: {
        blocks: inContentBlocks,
        minHeightPx,
      },
    },
    blockName: IN_CONTENT_SLOT_BLOCK_NAME,
    hasChild: false,
    innerHTML: '',
    tag: 'div',
    tagAttributes: { id: IN_CONTENT_SLOT_ID },
  };

  const spacedBlocks = prepareBlocksForInterrupts(blocks);
  const insertIndex = findLeadgenInsertIndex(spacedBlocks);
  spacedBlocks.splice(insertIndex, 0, sentinel);
  return { ...article, blocks: mergeUnbrokenListSplits(spacedBlocks) };
};
